@if (currentMedia(); as current) {
  <img
    loading="eager"
    alt="{{ current.altText }}"
    class="cx-media"
    [src]="current.src"
    [width]="width()"
    [height]="height()"
    (load)="onLoad()"
    (error)="onError($event)"
  />
}
